<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    methods: {
      /**
       * initial rem
       */
      initDocumentFontSize () {
        const resetFontSize = () => {
          const bodyWidth = document.body.clientWidth
          const fontSize = bodyWidth >= 750 ? 100 : 100 * bodyWidth / 750
          document.documentElement.style.fontSize = fontSize + 'px'
        }
        resetFontSize()
        window.addEventListener('load', () => {
          resetFontSize()
          window.timeOnPageStart = new Date()
        }, false)
        window.addEventListener('orientationchange', resetFontSize, false)
        window.addEventListener('resize', resetFontSize, false)
      }
    },
    created () {
      this.initDocumentFontSize()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "./global"
  /*@import 'nib'*/

  #app
    font-family: 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif
    background: background-color
    height: 100%
    width: 100%

  .loading
    absolute: top 50% left 50%
    width: 10%
    height: auto
    transform: translateX(-50%) translateY(-50%)
</style>



// WEBPACK FOOTER //
// src/App.vue